<template>
  <div id="filePrintPanel">
    <h1 id="fileHeader">File</h1>
    <a class="file--printbutton" @click="print">download</a>
    <a href="#fileHeader" />
    <Header
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      :related="related"
      @update="update"
    />
    <a href="#undertakings" />
    <Undertakings :departmentId="departmentId" :swiftMove="swiftMove" />
    <a href="#addressbook" />
    <Addressbook :departmentId="departmentId" :swiftMove="swiftMove" />
    <a href="#events" />
    <Events
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      :related="related"
    />
    <a href="#messages" />
    <Messages :departmentId="departmentId" :swiftMove="swiftMove" />
    <a href="#fundview" />
    <Fundview :departmentId="departmentId" :swiftMove="swiftMove" />
    <a href="#bills" />
    <Bills :departmentId="departmentId" :swiftMove="swiftMove" />
    <a href="#buyerpersonatags" />
    <BuyerPersonaTags :departmentId="departmentId" :swiftMove="swiftMove" />
    <a href="#reviews" />
    <Reviews :departmentId="departmentId" :swiftMove="swiftMove" />
  </div>
</template>

<script>
import Addressbook from "@/components/file/Addressbook";
import Bills from "@/components/file/Bills";
import BuyerPersonaTags from "@/components/file/BuyerPersonaTags";
import Events from "@/components/file/Events";
import Fundview from "@/components/file/Fundview";
import Header from "@/components/file/Header";
import Messages from "@/components/file/Messages";
import Reviews from "@/components/file/Reviews";
import Undertakings from "@/components/file/Undertakings";
import { printElement } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "File",
  components: {
    Addressbook,
    Bills,
    BuyerPersonaTags,
    Events,
    Fundview,
    Header,
    Messages,
    Reviews,
    Undertakings
  },
  data() {
    return {
      bottomNav: "fileHeader",
      toc: [
        {
          id: "fileHeader",
          text: "Header",
          target: "#fileHeader"
        },
        {
          id: "undertakings",
          text: "Undertakings",
          target: "#undertakings"
        },
        {
          id: "addressbook",
          text: "Address book",
          target: "#addressbook"
        },
        {
          id: "events",
          text: "Events",
          target: "#events"
        },
        {
          id: "messages",
          text: "Messages",
          target: "#messages"
        },
        {
          id: "fundview",
          text: "Fundview",
          target: "#fundview"
        },
        {
          id: "bills",
          text: "Bills",
          target: "#bills"
        },
        {
          id: "buyerpersonatags",
          text: "Buyer persona tags",
          target: "#buyerpersonatags"
        },
        {
          id: "reviews",
          text: "Reviews",
          target: "#reviews"
        }
      ],
      departmentId: null,
      swiftMove: null,
      related: null
    };
  },
  methods: {
    async fetchRelated() {
      try {
        const response = await nbmlaw.get(
          `/cors/admin/file/files/${this.$route.params.id}/related`
        );
        // console.log(response.data);
        this.related = response.data;
      } catch (err) {
        //do nothing
      }
    },
    update(departmentId, swiftMove) {
      this.departmentId = departmentId;
      this.swiftMove = swiftMove;
    },
    print() {
      printElement("filePrintPanel");
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchRelated();
        this.$store.commit("setTableOfContents", this.toc);
      }
    }
  }
};
</script>

<style>
@media print {
  .file--printbutton {
    display: none;
  }
}
.sectionHeading0 {
  margin-top: 15px;
  padding: 2px;
  background: black;
  color: white;
}

.sectionHeading1 {
  margin-top: 15px;
  padding: 2px;
  background: green;
  color: white;
}

.sectionHeading2 {
  margin-top: 15px;
  padding: 2px;
  background: orange;
  color: white;
}

.sectionHeading3 {
  margin-top: 15px;
  padding: 2px;
  background: red;
  color: white;
}

.sectionHeading7 {
  margin-top: 15px;
  padding: 2px;
  background: #663399;
  color: white;
}

.quoteAboveLarge {
  color: green;
  font-weight: bold;
}

.quoteAbove {
  color: green;
}

.quoteAverage {
}

.quoteBelow {
  color: red;
}

.quoteBelowLarge {
  color: red;
  font-weight: bold;
}

.headerDayCount {
  color: gray;
}

.warningLevel1 {
  background: #ffffff;
}

.warningLevel2 {
  background: #ffdddd;
}

.warningLevel3 {
  background: #ffbbbb;
}

.warningLevel4 {
  background: #ff9999;
}

.warningLevel5 {
  background: #ff7777;
}
</style>
